import { Result, Uuid } from '@standardnotes/domain-core';
export class DeleteAuthenticator {
    constructor(authenticatorClient) {
        this.authenticatorClient = authenticatorClient;
    }
    async execute(dto) {
        const authenticatorIdOrError = Uuid.create(dto.authenticatorId);
        if (authenticatorIdOrError.isFailed()) {
            return Result.fail(`Could not delete authenticator: ${authenticatorIdOrError.getError()}`);
        }
        const authenticatorId = authenticatorIdOrError.getValue();
        const result = await this.authenticatorClient.delete(authenticatorId);
        if (!result) {
            return Result.fail('Could not delete authenticator');
        }
        return Result.ok();
    }
}
